<template>
  <!--eslint-disable-->
  <el-dialog :title="title" :visible.sync="dialogVisible" width="70%" top="2vh">
    <div v-loading="contentLoading" class="body">
      <div style="margin-left: 40px">
        <div class="vm-separate">
          <span>{{$l('elevator.name', '电梯名称')}}：{{elevator.name}}</span>
          <span>{{$l('elevator.no', '电梯编号')}}：{{elevator.no}}</span>
        </div>
        <div class="vm-separate" style="margin-top: 20px">
          <span>{{$l('elevator.useUnit','使用单位')}}：{{elevator.useUnitName}}</span>
          <span>{{$t("monitor.parameters.times")}}：{{elevator.totalRunningCount > 0 ? elevator.totalRunningCount : "不支持"}} {{elevator.totalRunningCount > 0 ? $l("elevator.count", "次") : ""}}</span>
        </div>
      </div>
      <ul v-for="groupItem in group" style="margin-top: 20px">
        <el-row>
          <li>
            <div style="width: 100%;margin-bottom:10px;background-color: #F2F6FC;"><b>{{ groupItem }}</b></div>
            <ul v-for="data in listData">
              <li v-if="data.type === groupItem" class="groupItem">
                <div style="width: 110px" @click="handleClick(data)">
                  <el-progress type="circle"
                               :percentage="data.value === -1 ? 0 : data.value <= 0 ? 0.1 : data.value"
                               :format="format"
                               :width="100">
                    </el-progress>
                  <div>&nbsp;&nbsp;&nbsp;{{ data.beginTime }}</div>
                  <div>&nbsp;{{ $t("common.to") + " " + data.endTime }}</div>
                </div>
              </li>
            </ul>
          </li>
        </el-row>
      </ul>
      <details-dialog ref="detailsPage"></details-dialog>
    </div>
  </el-dialog>
</template>

<script>
  import DetailsDialog from "./PotentialFaultDetails.vue";

  const moduleName = "potentialFaults";

  export default {
    components: { DetailsDialog },
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        id: 0,
        group: [],
        listData: [],
        elevator: {
          no: "",
          name: "",
          totalRunningCount: "",
          useUnitName: "",
        }
      };
    },
    computed: {
      title() {
        return this.$t("potentialFault.healthIndex");
      },
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.id = row.id;
        this.elevator = row;
        if (this.id > 0) {
          this.getData();
        }
      },
      getData() {
        this.$http.get("potentialFaults/" + this.id).then(res => {
          this.listData = res.data;
          this.contentLoading = false;
          this.initGroup();
        }).catch((error) => {
          this.contentLoading = false;
          if (error.response) {
            this.$message.error(this.$t("common.tip.getDataError") + error.response.data.message);
          }
        });
      },
      initGroup() {
        for (let dataItem of this.listData) {
          this.setGroup(dataItem.type);
        }
      },
      setGroup(type) {
        let result = false;
        for (let groupItem of this.group) {
          if (type === groupItem) {
            result = true;
          }
        }
        if (!result) {
          this.group.push(type);
        }
      },
      handleClick(data) {
        if (data[3] > 0) {
          let elevatorId = this.id;
          let potentialFaultSettingId = data.potentialFaultSettingId;
          let beginTime = data.beginTime;
          let pro = {
            "elevatorId": elevatorId,
            "potentialFaultSettingId": potentialFaultSettingId,
            "beginTime": beginTime,
          };
          this.$refs.detailsPage.open(pro);
        }
      },
      format(value) {
        return value === 0 ? "不支持" : value === 0.1 ? "0" : value;
      },
    },
  };
</script>

<style lang="scss" scoped>
li {
  list-style-type: none;
}

.groupItem {
  float: left;
}
</style>
